module.exports = __webpack_public_path__ + "static/media/29FUNOV14.1517a14c.jpg";